import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FocusRestoreService {
  readonly attrKey = 'data-focus-key';
  private focusedElementId: string = null;

  storeFocusedId(id: string): void {
    this.focusedElementId = id;
  }

  getAndClearFocusedId(): string {
    const id = this.focusedElementId;
    this.focusedElementId = null;
    return id;
  }
}
